import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'formly-checkbox-type',
  template: `
    <div class="field p-fluid mb-3 mt-1">
      <div class="field-checkbox">
        <p-checkbox
          [formControl]="formControl"
          [formlyAttributes]="field"
          [binary]="true"
          [inputId]="checkboxId"
        ></p-checkbox>
        <label
          class="block"
          [for]="checkboxId"
          >{{ field.templateOptions.label }}</label
        >
      </div>

      <div
        *ngIf="formControl.errors"
        class="text-sm mt-2 p-error"
      >
        <formly-validation-message
          [field]="field"
        ></formly-validation-message>
      </div>

      <div
        *ngIf="
          field.templateOptions.description && !formControl.errors
        "
        class="text-sm"
      >
        {{ field.templateOptions.description }}
      </div>

      <div
        *ngIf="
          props && props.attributes && props.attributes['warning']
        "
        class="text-sm my-1 text-yellow-400"
      >
        <span
          class="font-bold"
          i18n
          >Warnung:</span
        >
        {{ props.attributes['warning'] }}
      </div>
    </div>
  `,
})
export class CheckboxTypeComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  checkboxId: string;

  ngOnInit(): void {
    // This is necessary so the user is able to click the label instead of the checkbox.
    // For some reason we can't use field.id
    this.checkboxId = uuidv4();
  }
}
